import React from "react";
import { useTranslation } from "react-i18next";
import {
  CreditCard,
  Package,
  Receipt,
  BarChart3,
  Store,
  Users,
  WifiOff,
  ShoppingCart,
  ShieldCheck,
} from "lucide-react";

const Features = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: <CreditCard size={24} />,
      title: t("Lightning-fast cashier"),
      desc: t("Scan barcodes, accept cash, card, mobile wallet (InstaPay, Vodafone Cash, Fawry) and split payments in one tap."),
    },
    {
      icon: <Package size={24} />,
      title: t("Smart inventory"),
      desc: t("Multi-branch stock, low-stock alerts, expiry tracking, supplier management and purchase orders - automated."),
    },
    {
      icon: <Receipt size={24} />,
      title: t("Arabic receipts"),
      desc: t("Print or send WhatsApp/SMS receipts in Arabic or English with your logo, address and tax number."),
    },
    {
      icon: <BarChart3 size={24} />,
      title: t("Live dashboards"),
      desc: t("See revenue, profit, top products and staff performance in real time - on your phone, anywhere."),
    },
    {
      icon: <Store size={24} />,
      title: t("Multi-branch"),
      desc: t("Run unlimited branches under one account. Transfer stock, set permissions, consolidate reports."),
    },
    {
      icon: <ShieldCheck size={24} />,
      title: t("ETA e-invoice ready"),
      desc: t("Compliant with Egyptian Tax Authority e-invoice and e-receipt requirements out of the box."),
    },
  ];

  return (
    <section id="features" className=" bg-[#F4F7FF]">
      <div className="mx-auto px-5" style={{ maxWidth: "1180px" }}>

        {/* Section Head */}
        <div className="mx-auto mb-14 max-w-[700px] text-center">
          <h2 className="mb-3 text-[clamp(28px,3.6vw,44px)] font-black leading-[1.12] tracking-[-1.2px] text-gray-900">
            {t("One app to run the entire store")}
          </h2>
          <p className="text-[17px] leading-relaxed text-gray-500">
            {t("Built for Egyptian retailers - supermarkets, pharmacies, fashion, electronics, restaurants and salons. No installs. No long contracts.")}
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <article
              key={index}
              className="relative overflow-hidden rounded-[20px] border-[1.5px] border-gray-200 bg-white p-7 transition-all duration-300 hover:-translate-y-[4px] hover:border-[#1B4597]"
            >
              {/* Top accent line */}
              <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#1B4597] to-[#2557C7] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              {/* Icon */}
              <div
                className="mb-5 grid h-[52px] w-[52px] place-items-center rounded-[14px] text-[#1B4597]"
                style={{ background: "linear-gradient(135deg, #dbeafe, #eff6ff)" }}
              >
                {feature.icon}
              </div>

              {/* Title */}
              <h3 className="mb-2 text-[17.5px] font-extrabold tracking-[-0.3px] text-gray-900">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-[14px] leading-[1.65] text-gray-500">
                {feature.desc}
              </p>
            </article>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Features;